import { CloseOutlined, EditTwoTone, SaveOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row } from "antd";
import React, { useEffect, useState } from "react";
import { Utils } from "../../Utilities/Utils";
import PracticesService, {
  IGeneralSettingsInitialValues,
  PracticeUpdateTypes,
} from "../../Services/PracticesService";
import { adminContext } from "../../Common/PageRoute";
import { usePractice } from "../../Context/PracticeContext";
import { useUser } from "../../Context/UserContext";

interface GeneralSettingsProps {
  isEdit: { type: PracticeUpdateTypes };
  setIsEdit: React.Dispatch<
    React.SetStateAction<{ type: PracticeUpdateTypes }>
  >;
  generalSettingsData: IGeneralSettingsInitialValues;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  practiceId: number;
  setPracticeGS: React.Dispatch<
    React.SetStateAction<IGeneralSettingsInitialValues>
  >;
}

interface IGeneralSettingsIntialValues {
  name: string;
  connectionString: string;
  database: string;
  host: string;
  identifier: string;

}
const GeneralSettings = ({
  setLoading,
  isEdit,
  setIsEdit,
  generalSettingsData,
  practiceId,
  setPracticeGS,
}: GeneralSettingsProps) => {
  const { openNotification } = React.useContext(adminContext);
  const { isSubAdmin } = useUser();
  const { updatePractice } = usePractice();
  const isViewOnly = isSubAdmin();
  const [form] = Form.useForm();
  // const { reloadPractices } = usePractice();
  const [intialValues, setInitialValues] =
    useState<IGeneralSettingsIntialValues>({
      name: "",
      connectionString: "",
      database: "",
      host: "",
      identifier: "",
    });

  useEffect(() => {
    if (generalSettingsData) {
      const fieldValues = {
        name: generalSettingsData.name,
        connectionString: generalSettingsData.connectionString,
        database: generalSettingsData.database,
        host: generalSettingsData.host,
        identifier: generalSettingsData.identifier,
      };
      form.setFieldsValue(fieldValues);
      setInitialValues(fieldValues);
    }
  }, [generalSettingsData, form]);

  const OnSaveClick = async () => {
    setLoading(true);

    try {
      const values = await form.validateFields();
      const res = await PracticesService.updatePracticeGeneralSettings(
        practiceId,
        values,
      );
      // await reloadPractices();
      if (res?.result) {
        updatePractice({
          label: values.name,
          value: practiceId
        })
        setPracticeGS(values);
        openNotification("success", "Practice details updated successfully");
        setIsEdit({ type: PracticeUpdateTypes.unknown });
        setInitialValues(values);
      } else {
        openNotification(
          "error",
          res?.message || "Error updating practice details",
        );
      }
    } catch (error) {
      openNotification("error", "Please fill all mandatory fields.");
    } finally {
      setLoading(false);
    }
  };
  const handleCancel = () => {
    if (intialValues) {
      form.setFieldsValue(intialValues);
    }
    setIsEdit({ type: PracticeUpdateTypes.unknown });
  };

  return (
    <>
      <Form
        form={form}
        // onValuesChange={handleValuesChange}
        disabled={isViewOnly}
      >
        
        <Col className="card border pb-3 border-rounded-1 bg-secondary">
          <Row
            className="border-bottom  px-2 py-1 font-bold"
            justify="space-between"
          >
            General settings
            {!isViewOnly &&
              <Button
                icon={<EditTwoTone />}
                type="text"
                // disabled={isInactive}
                style={{ border: "none" }}
                onClick={() =>
                  setIsEdit({ type: PracticeUpdateTypes.generalSettings })
                }
              />
            }
          </Row>
          <Row className="px-3 pt-1">
            <Col span={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 12 }}
                label="Name"
                name="name"
                rules={[
                  { required: true, message: "Name is requried" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              >
                <Input
                  disabled={
                    isEdit.type === PracticeUpdateTypes.generalSettings
                      ? false
                      : true
                  }
                  onInput={(e: any) =>
                  (e.target.value =
                    e.target.value.length > 1
                      ? e.target.value
                      : e.target.value.toUpperCase())
                  }
                  className="line-height-28"
                  placeholder="Name"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="Database name"
                // name={["tenantDetails", "database"]}
                name="database"
                rules={[
                  { required: true, message: "Database name is requried" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              >
                <Input
                  disabled={
                    isEdit.type === PracticeUpdateTypes.generalSettings
                      ? false
                      : true
                  }
                  className="line-height-28"
                  placeholder="Database name"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Connection string"
                // name={["tenantDetails", "connectionString"]}
                name="connectionString"
                rules={[
                  { required: true, message: "Connection string is requried" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              >
                <Input
                  disabled={
                    isEdit.type === PracticeUpdateTypes.generalSettings
                      ? false
                      : true
                  }
                  onKeyPress={(e) => Utils.ValidateCharOnly(e)}
                  className="line-height-28"
                  placeholder="Connection string"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="px-3">
            <Col span={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 12 }}
                label="Host"
                // name={["tenantDetails", "host"]}
                name="host"
                rules={[
                  { required: true, message: "Host is requried" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              >
                <Input
                  disabled={
                    isEdit.type === PracticeUpdateTypes.generalSettings
                      ? false
                      : true
                  }
                  className="line-height-28"
                  placeholder="Host"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="Identifier"
                // name={["tenantDetails", "identifier"]}
                name="identifier"
                rules={[
                  { required: true, message: "Identifier is requried" },
                  { validator: Utils.validateWhiteSpace },
                ]}
              >
                <Input
                  disabled={
                    isEdit.type === PracticeUpdateTypes.generalSettings
                      ? false
                      : true
                  }
                  className="line-height-28"
                  placeholder="Identifier"
                />
              </Form.Item>
            </Col>
          </Row>
          {!isViewOnly && isEdit.type === PracticeUpdateTypes.generalSettings && (
            <Row className="px-3 pt-3">
              <Button type="primary" onClick={OnSaveClick}>
                <SaveOutlined /> Save
              </Button>
              <Button className="ms-2" onClick={handleCancel}>
                <CloseOutlined /> Cancel
              </Button>
            </Row>
          )}
        </Col>       
        {/* <Col className="card border pb-3 border-rounded-1 bg-secondary my-4">
          <Row
            style={{ paddingTop: 4, paddingBottom: 15 }}
            className="px-2 font-bold border-bottom"
            justify="space-between"
          >
            User details
          </Row>
          <Col span={24} style={{ padding: "0px 10px" }}>
            <UserDetails practiceId={parseInt(id ?? "0")} />
          </Col>
        </Col> */}
      </Form>
    </>
  );
};
export default GeneralSettings;
